module.exports = __webpack_public_path__ + "img/alcohol-icon.0e2b8ab5.svg";